import { db } from "../../../service/API";

export class LoginConnector {
  constructor() {}

  getLoginData(login, pwd) {
    return new Promise((resolve, reject) => {
      db.post("/LogConnector/LoginData/", { login: login, password: pwd })
        .then((response) => {
          // If user found status 200
          if (response.status == 200) {
            return resolve(response.data);
          }
          // If user not found status 404
          else if (response.status == 404) {
            return resolve(response.data);
          }
          // Else there is a problem
          else {
            return reject("get login data failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get login data failed with error : ", err);
        });
    });
  }
}
